module.exports = __webpack_public_path__ + "img/image9.fd214e22.png";